import {
  TARIFFS_TO_BENEFITS,
  TARIFF_BASIC,
  TARIFF_HIGH,
  TARIFF_MEDIUM,
  TARIFF_MEDIUM_EXTRA,
  TARIFF_PREMIUM,
} from '../constants.js';

/**
 * @property {string} sn
 * @property {string} subscriptionId
 * @property {boolean} isFixed
 * @property {string} nickname
 * @property {string} tariffName
 * @property {boolean} isLove17GrowEligible - whether member was returned from product offering and therefore is eligible for love 17 GROW
 */
export default class LoveMember {
  /**
   * @param {string} sn
   * @param {string} subscriptionId
   * @param {boolean} isFixed
   * @param {string} nickname
   * @param {string} tariffName
   * @param {boolean} isLove17GrowEligible
   */
  constructor({ sn, subscriptionId, isFixed, nickname, tariffName, isLove17GrowEligible = false }) {
    this.sn = sn;
    this.subscriptionId = subscriptionId;
    this.isFixed = isFixed;
    this.nickname = nickname;
    this.tariffName = tariffName;
    this.isLove17GrowEligible = isLove17GrowEligible;
  }

  /**
   * @returns {?('tariff-level-basic'|'tariff-level-medium'|'tariff-level-medium-extra'|'tariff-level-high'|'tariff-level-premium')}
   */
  get growTariffLevel() {
    if (this.isFixed) {
      return null;
    }
    if (this.tariffName.startsWith('Základný ')) {
      return TARIFF_BASIC;
    }
    if (this.tariffName.startsWith('Stredný Extra ')) {
      return TARIFF_MEDIUM_EXTRA;
    }
    if (this.tariffName.startsWith('Stredný ')) {
      return TARIFF_MEDIUM;
    }
    if (this.tariffName.startsWith('Veľký ')) {
      return TARIFF_HIGH;
    }
    if (this.tariffName.startsWith('Prémiový ')) {
      return TARIFF_PREMIUM;
    }
    return null;
  }

  /**
   * @returns {boolean}
   */
  get isGrowVoice() {
    return this.isLove17GrowEligible && !this.isFixed;
  }

  /**
   * @returns {?('benefit-level-basic'|'benefit-level-medium'|'benefit-level-high'|'benefit-level-premium')}
   */
  get expectedGrowBenefitLevel() {
    return TARIFFS_TO_BENEFITS[this.growTariffLevel] ?? null;
  }
}
